import { useQuery } from "@tanstack/react-query";
import { api } from "@/config/api-fetch";

export interface SearchQuery {
    id: number;
    query: string;
    answer: string;
    is_helpful: boolean | null;
    created_at: string;
}

export interface SearchQueriesResponse {
    queries: SearchQuery[];
    total: number;
    page: number;
    per_page: number;
}

export function useSearchQueries(page: number = 1, per_page: number = 20) {
    return useQuery<SearchQueriesResponse>({
        queryKey: ["search-queries", page, per_page],
        queryFn: async () => api.get(`/search-queries?page=${page}&per_page=${per_page}`),
    });
}
